import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pwa-desktop',
  templateUrl: './pwa-desktop.component.html',
  styleUrls: ['./pwa-desktop.component.scss']
})
export class PwaDesktopComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
